jQuery(document).ready(function($) {
    'use strict';

    var warning = $('.news-banner');

    $(document).on('click', '.news-banner .icon-close', function() {
        warning.toggleClass('hidden');

        setCookie('newsBanner');
    });

    function setCookie(cookieName) {
        const cookieValue = 'Cookie';
        const cookieExpireDays = 30;

        let currentDate = new Date();
        currentDate.setTime(
            currentDate.getTime() + cookieExpireDays * 24 * 60 * 60 * 1000,
        );
        let expires = 'expires=' + currentDate.toGMTString();
        document.cookie =
            cookieName + '=' + cookieValue + ';' + expires + ';path=/';

    }

    function getCookie(cookie_name) {
        let name = cookie_name + '=';
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return null;
    }

    function checkDisplayNewsBanner() {
        var newsBanner = getCookie("newsBanner");

        if (newsBanner === null) {
            $("#newsbanner").removeClass("hidden");
        } else {
            $("#newsbanner").addClass("hidden");
        }
    }

    window.addEventListener("load", checkDisplayNewsBanner);
});